import React from "react";
import { Link } from "react-router-dom";
import logo from '../Landing/assets/logo.svg';
import { useSelector } from "react-redux";

export default function Logo() {
  // redux
  const { loggedin } = useSelector((state) => state.app);
  return (
    <Link to={loggedin ? "/app" : "/"} className="logo-placeholder d-flex align-items-center">
      <img src={logo} alt="Logo"/><span className="d-none d-md-block">Bluesphere<br/>Carbon</span>
    </Link>
  );
}
